export default "__VITE_ASSET__BulnC$1d__"